import { paths } from '@/configs/paths'
import { ROLES, type UserRole } from '@/constants/common'

export const getRedirectPathByRole = (role?: UserRole | undefined): string => {
  switch (role) {
    case ROLES.DISTRIBUTOR_ADMIN:
      return paths.inStock.path
    case ROLES.CUSTOMER_STAFF:
      return paths.stockersList.path
    case ROLES.CUSTOMER_ADMIN:
      return paths.selectMode.path
    case ROLES.DELIVERY_STAFF:
      return paths.deliveryStaff.path
    case ROLES.SYSTEM:
      return paths.distributorManage.path
    default:
      return paths.inStock.path
  }
}
